import { useMapsLibrary } from '@vis.gl/react-google-maps'

interface IGoogleMapsLibraries {
  isLoaded: boolean
  geometryLib: google.maps.GeometryLibrary | null
}

export const useGoogleMapsScript = (): IGoogleMapsLibraries => {
  const geometryLib = useMapsLibrary('geometry')

  return {
    isLoaded: !!geometryLib,
    geometryLib
  }
}
